import { all, fork, put, takeEvery } from "redux-saga/effects";

import {

    // Inventory Management
    SETTING_LOAD_INVENTORY_CATEGORY,
    SETTING_CREATE_INVENTORY_CATEGORY,
    SETTING_UPDATE_INVENTORY_CATEGORY,
    SETTING_DELETE_INVENTORY_CATEGORY,

    SETTING_LOAD_INVENTORY,
    SETTING_CREATE_INVENTORY,
    SETTING_UPDATE_INVENTORY,
    SETTING_DELETE_INVENTORY,

    // SETTING_UPDATE_INVENTORY_STATUS,
    // END Inventory Management

} from "../../actions";

import {
    // Inventory Management
    settingGetInventoryCategory,
    settingAddInventoryCategory,
    settingUpdateInventoryCategory,
    settingDeleteInventoryCategory,

    settingGetInventory,
    settingAddInventory,
    settingUpdateInventory,
    settingDeleteInventory,
    // settingUpdateChangeStatusInventory,

    // END Inventory Management

} from "../../../helpers/setting-api";

import {
    getInventoryCategory,
    getInventoryCategorySuccess,
    getInventory,
    getInventorySuccess,
} from "./actions";

import { NotificationManager } from '../../../components/common/react-notifications';

const PullNotificationManager = async (text) => {
    // eslint-disable-next-line no-return-await
    await NotificationManager.warning(text, 'Error', 3000, null, null, '');
}

// Inventory Management
function* settingManagementLoadInventoryCategory({ payload, token }) {
    try {
        const dataRes = yield settingGetInventoryCategory(payload, token);
        if (dataRes.status === 'success') {
            // let list = [];
            // const dataFilter = dataRes.data.filter(el => el.name_department === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_department !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_inventory_category,
                    value: item.id_inventory_category,
                }
            ));
            yield put(getInventoryCategorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddInventoryCategory({ payload, token }) {
    try {
        const dataRes = yield settingAddInventoryCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getInventoryCategory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateInventoryCategory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateInventoryCategory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getInventoryCategory({ spa_id: payload.spa_id }, token));
            yield put(getInventory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementDeleteInventoryCategory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteInventoryCategory(items, token);
        if (dataRes.status === 'success') yield put(getInventoryCategory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementLoadInventory({ payload, token }) {
    try {
        const dataRes = yield settingGetInventory(payload, token);
        if (dataRes.status === 'success') {
            // const dataFilter = dataRes.data.filter(el => el.name_position === "Owner")
            // const allDataFilter = dataRes.data.filter(el => el.name_position !== "Owner")
            // const checkDataFilter = [...dataFilter || (null), ...allDataFilter || dataRes.data]
            const list = dataRes.data.map(item => (
                {
                    ...item,
                    label: item.name_inventory_product,
                    value: item.id_inventory_product,
                }
            ));
            yield put(getInventorySuccess(dataRes.data, list));
        } else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementAddInventory({ payload, token }) {
    try {
        const dataRes = yield settingAddInventory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getInventory({ spa_id: payload.spa_id }, token));
        } else
            if
                (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }

            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else {
                yield PullNotificationManager(`${dataRes.msg}`);
            }

    } catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

function* settingManagementUpdateInventory({ payload, token }) {
    try {
        const dataRes = yield settingUpdateInventory(payload, token);
        if (dataRes.status === 'success') {
            yield put(getInventory({ spa_id: payload.spa_id }, token));
            // yield put(getInventoryCategory({ spa_id: payload.spa_id }, token));
            // yield put(getPosition({ idHotel }, token));
            // yield put(getUser());
        } else
            if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
                yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
                // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
            }
            else if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// function* settingManagementChangeStatusInventory({ payload, token }) {
//     try {
//         const dataRes = yield settingUpdateChangeStatusInventory(payload, token);
//         if (dataRes.status === 'success') {
//             yield put(getInventory({ spa_id: payload.spa_id }, token));

//         } else
//             if (dataRes.status === 'error' && dataRes.err.code === 'ER_DUP_ENTRY') {
//                 yield PullNotificationManager("Oops! The data name is duplicated. Please change the data name.")
//                 // yield put(settingErrorMessage("Oops! The data name is duplicated. Please change the data name."));
//             }
//             else if (dataRes.status === 'error' && dataRes.auth === false) {
//                 yield PullNotificationManager("TIME OUT! Please Login again.")
//                 // yield put(settingErrorMessage("TIME OUT! Please Login again."))
//             } else {
//                 yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//                 // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//             }
//     }
//     catch (error) {
//         yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
//         // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
//     }
// }

function* settingManagementDeleteInventory({ payload, token }) {
    const { items } = payload;
    try {
        const dataRes = yield settingDeleteInventory(items, token);
        if (dataRes.status === 'success') yield put(getInventory({ spa_id: payload.spa_id }, token));
        else
            if (dataRes.status === 'error' && dataRes.auth === false) {
                yield PullNotificationManager("TIME OUT! Please Login again.")
                // yield put(settingErrorMessage("TIME OUT! Please Login again."))
            }
            else if (dataRes.err.code === "ER_ROW_IS_REFERENCED_2") {
                yield PullNotificationManager("RoleCategory is used.");
            } else {
                yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
                // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
            }
    }
    catch (error) {
        console.log('error', error)
        yield PullNotificationManager("OMG! Please wait about 30s and refresh your browser again.")
        // yield put(settingErrorMessage("OMG! Please wait about 30s and refresh your browser again."));
    }
}

// END Inventory Management

// Inventory Management
export function* watchLoadInventoryCategory() {
    yield takeEvery(
        SETTING_LOAD_INVENTORY_CATEGORY,
        settingManagementLoadInventoryCategory
    );
}
export function* watchAddInventoryCategory() {
    yield takeEvery(
        SETTING_CREATE_INVENTORY_CATEGORY,
        settingManagementAddInventoryCategory
    );
}
export function* watchUpdateInventoryCategory() {
    yield takeEvery(
        SETTING_UPDATE_INVENTORY_CATEGORY,
        settingManagementUpdateInventoryCategory
    );
}
export function* watchDeleteInventoryCategory() {
    yield takeEvery(
        SETTING_DELETE_INVENTORY_CATEGORY,
        settingManagementDeleteInventoryCategory
    );
}

export function* watchLoadInventory() {
    yield takeEvery(
        SETTING_LOAD_INVENTORY,
        settingManagementLoadInventory
    );
}
export function* watchAddInventory() {
    yield takeEvery(
        SETTING_CREATE_INVENTORY,
        settingManagementAddInventory
    );
}
export function* watchUpdateInventory() {
    yield takeEvery(
        SETTING_UPDATE_INVENTORY,
        settingManagementUpdateInventory
    );
}
// export function* watchChangeStatusInventory() {
//     yield takeEvery(
//         SETTING_UPDATE_INVENTORY_STATUS,
//         settingManagementChangeStatusInventory
//     );
// }
export function* watchDeleteInventory() {
    yield takeEvery(
        SETTING_DELETE_INVENTORY,
        settingManagementDeleteInventory
    );
}

// END Inventory Management

export default function* rootSaga() {
    yield all([
        //  Inventory Management 
        fork(watchLoadInventoryCategory),
        fork(watchAddInventoryCategory),
        fork(watchUpdateInventoryCategory),
        fork(watchDeleteInventoryCategory),

        fork(watchLoadInventory),
        fork(watchAddInventory),
        fork(watchUpdateInventory),
        // fork(watchChangeStatusInventory),
        fork(watchDeleteInventory),

    ])
}